var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymptomsCheckerBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1778_7853)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.50258 8.52002C6.20258 9.31258 6.20258 10.1875 6.50258 10.98C5.90591 10.6261 5.34569 10.2141 4.83008 9.75002C5.34569 9.28592 5.90591 8.87391 6.50258 8.52002Z",
    fill: "#41ABC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.74984 11.7223C10.8392 11.7223 11.7223 10.8392 11.7223 9.74984C11.7223 8.66046 10.8392 7.77734 9.74984 7.77734C8.66046 7.77734 7.77734 8.66046 7.77734 9.74984C7.77734 10.8392 8.66046 11.7223 9.74984 11.7223Z",
    fill: "#41ABC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.998 8.52002C13.5947 8.87391 14.1549 9.28592 14.6705 9.75002C14.1549 10.2141 13.5947 10.6261 12.998 10.98C13.298 10.1875 13.298 9.31258 12.998 8.52002Z",
    fill: "#41ABC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75 0C7.82164 0 5.93657 0.571828 4.33319 1.64317C2.72982 2.71452 1.48013 4.23726 0.742179 6.01884C0.00422452 7.80042 -0.188858 9.76082 0.187348 11.6521C0.563554 13.5434 1.49215 15.2807 2.85571 16.6443C4.21928 18.0079 5.95656 18.9365 7.84787 19.3127C9.73919 19.6889 11.6996 19.4958 13.4812 18.7578C15.2627 18.0199 16.7855 16.7702 17.8568 15.1668C18.9282 13.5634 19.5 11.6784 19.5 9.75C19.4975 7.1649 18.4695 4.68638 16.6416 2.85843C14.8136 1.03048 12.3351 0.00246227 9.75 0ZM16.305 10.2525C16.185 10.3875 13.3575 13.47 9.75 13.47C6.1425 13.47 3.315 10.3875 3.195 10.2525C3.06844 10.1158 2.99813 9.93632 2.99813 9.75C2.99813 9.56368 3.06844 9.38423 3.195 9.2475C3.315 9.1125 6.1425 6.03 9.75 6.03C13.3575 6.03 16.185 9.1125 16.305 9.2475C16.4316 9.38423 16.5019 9.56368 16.5019 9.75C16.5019 9.93632 16.4316 10.1158 16.305 10.2525Z",
    fill: "#41ABC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0006 21.7501C24.0009 22.1952 23.8691 22.6303 23.622 23.0004C23.3749 23.3704 23.0234 23.6589 22.6123 23.8291C22.2011 23.9994 21.7487 24.0438 21.3122 23.9567C20.8758 23.8697 20.475 23.6551 20.1606 23.3401L15.9531 19.1326C17.2127 18.293 18.2935 17.2122 19.1331 15.9526L23.3406 20.1601C23.5505 20.3682 23.717 20.6159 23.8303 20.8889C23.9436 21.1618 24.0015 21.4546 24.0006 21.7501Z",
    fill: "#41ABC8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1778_7853"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymptomsCheckerBlue);
export default __webpack_public_path__ + "static/media/symptoms-checker-blue.81abee3001193f48a142f5a56d6a59b2.svg";
export { ForwardRef as ReactComponent };